// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t439","icon":"styles_icon__3rI8H"};